export default `
  landlordHomecards(locale: $locale) {
    checked
    currencyIsoCode
    firstAvailableDate
    id
    isInstantBooking
    noSecurityDeposit
    isFavorite
    mainPhotoUrl
    location
    monthlyPrice {
      fixedPrice
      minimumPrice
      pricesByMonth {
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
      }
      type
    }
    photoUrls {
      homecardHidpi
      homecard
    }
    photos
    reviews {
      ratingAverage
    }
    title
    description
    type
    url
    features
    area
    offers {
      discountType
      discountValue
    }
    allowsPermanentContract
    numberOfBathrooms
    isBestChoice
    plan
    bills
    billsIncluded
  }
`;
